import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { Table, Button } from "react-bootstrap";
import { KeyFill, Trash } from "react-bootstrap-icons";

import { useUiFeedback } from "../../../../context/ui-feedback/ui-feedback";
import { createConfirmFeedback } from "../../../../context/ui-feedback/action";
import { Loading } from "../../../common/loading/loading";

export const MobileAppTable = ({
  rowNumberInit,
  apps,
  hasError,
  handleDelete,
}) => {
  const intl = useIntl();

  const { uiFeedbackDispatch } = useUiFeedback();

  const TableBody = ({ apps, rowNumberInit }) => {
    if (apps.length === 0) {
      return (
        <tr>
          <td colSpan={7}>
            <span className="text-danger">
              <b>
                <FormattedMessage id="data.apps.warning.notfoundapps" />
              </b>
            </span>
          </td>
        </tr>
      );
    }

    const setDeleteConfirm = (app) => {
      createConfirmFeedback(
        uiFeedbackDispatch,
        intl.formatMessage({
          id: "page.apps.label.deletetapp.title",
        }),
        intl.formatMessage(
          {
            id: "page.apps.label.deletetapp.question",
          },
          {
            name: app?.user.name,
            key: app.deviceKey,
          },
        ),
        () => {
          handleDelete(app);
        },
      );
    };

    return apps.map((app, index) => (
      <tr key={app.deviceKey}>
        <td className="col-rownumber">{rowNumberInit + index + 1}.</td>
        <td className="col-key">
          {app.registred ? (<KeyFill className="me-2" />) : null}
          {app.deviceKey}
        </td>
        <td className="col-user">{app.user.name}</td>
        <td className="col-creator">{app.createdUser.name}</td>
        <td className="col-created">{app.createdDate}</td>
        <td className="col-lastSync">{app.lastSyncDate}</td>
        <td className="col-actions">
          <Button
            className="me-2"
            variant="outline-secondary"
            title={intl.formatMessage({
              id: "page.apps.button.delete",
            })}
            onClick={() => setDeleteConfirm(app)}
          >
            <Trash />
          </Button>
        </td>
      </tr>
    ));
  };

  const LoadingBody = ({ hasError }) => (
    <tr>
      <td colSpan={7}>
        {hasError ? (
          <span className="text-danger">
            <FormattedMessage id="data.apps.exception.listApps" />
          </span>
        ) : (
          <Loading />
        )}
      </td>
    </tr>
  );

  return (
    <>
      <div className="apps-table-component table-responsive">
        <Table striped bordered>
          <thead>
            <tr>
              <th className="col-rownumber">#</th>
              <th className="col-key">
                <FormattedMessage id="data.apps.data.key" />
              </th>
              <th className="col-user">
                <FormattedMessage id="data.apps.data.user" />
              </th>
              <th className="col-creator">
                <FormattedMessage id="data.apps.data.creator" />
              </th>
              <th className="col-created">
                <FormattedMessage id="data.apps.data.created" />
              </th>
              <th className="col-lastSync">
                <FormattedMessage id="data.apps.data.lastSync" />
              </th>
              <th className="col-actions"></th>
            </tr>
          </thead>
          <tbody>
            {apps ? (
              <TableBody apps={apps} rowNumberInit={rowNumberInit} />
            ) : (
              <LoadingBody hasError={hasError} />
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
};

MobileAppTable.propTypes = {
  rowNumberInit: PropTypes.number.isRequired,
  apps: PropTypes.array,
  hasError: PropTypes.bool.isRequired,
  handleDelete: PropTypes.func.isRequired,
};
